import React from "react";

// Google Tag Manager NoScript Component
// Este componente debe incluirse inmediatamente después del <body> opening tag
const GTMNoScript = () => {
  const GTM_CONTAINER_ID =
    process.env.REACT_APP_GTM_CONTAINER_ID || "GTM-TKN6RZWJ";

  // Solo renderizar en producción
  if (process.env.NODE_ENV === "development") {
    return null;
  }

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${GTM_CONTAINER_ID}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
        title="Google Tag Manager"
      />
    </noscript>
  );
};

export default GTMNoScript;
